import React from 'react'
import OutboundArrowIcon from '../icons/OutboundArrowIcon'
import { formatDisplayUrl } from '../../lib/urlFormatting'

interface OutboundLinkProps {
  href?: string
  className?: string
  title?: string
  /** When true, shows only the link-out icon without URL text */
  iconOnly?: boolean
}

export default function OutboundLink({ href, className, title, iconOnly = false }: OutboundLinkProps) {
  if (!href) return null
  const display = formatDisplayUrl(href)
  
  if (iconOnly) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className={`inline-flex items-center ${className || 'text-blue-600 dark:text-blue-400 hover:text-blue-500'}`}
        title={title || display}
      >
        <OutboundArrowIcon className="w-3.5 h-3.5" />
      </a>
    )
  }
  
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center gap-1 ${className || 'text-blue-600 dark:text-blue-300 hover:underline'}`}
      title={title || href}
    >
      <OutboundArrowIcon />
      <span className="truncate max-w-[220px] text-xs font-mono">{display}</span>
    </a>
  )
}


